import tuningForkIframeLoader from 'lib/tuning-fork/parent-iframe/loader';
import bindPrivacyPageForm from './bindPrivacyPageForm';

tuningForkIframeLoader();
bindPrivacyPageForm();
